import { render } from "./inventariogeneralrestaurante.vue?vue&type=template&id=1f189ae7&scoped=true"
import script from "./inventariogeneralrestaurante.vue?vue&type=script&lang=js"
export * from "./inventariogeneralrestaurante.vue?vue&type=script&lang=js"

import "./inventariogeneralrestaurante.vue?vue&type=style&index=0&id=1f189ae7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f189ae7"]])

export default __exports__